<template>
  <div class="flex flex-col items-center gap-0.5 py-1" data-cy="week-day-header">
    <span class="text-xxs font-medium uppercase text-gray-500">
      {{ dayLetter }}
    </span>
    <span
      v-if="isToday"
      class="flex h-6 w-6 items-center justify-center rounded-full bg-blue-600 text-sm font-semibold text-white"
    >
      {{ dayNumber }}
    </span>
    <span v-else class="text-sm font-semibold text-gray-900">
      {{ dayNumber }}
    </span>
  </div>
</template>

<script setup lang="ts">
import moment from "moment-timezone";
import { computed } from "vue";

/**
 * One column header in the phone week grid: the day's letter over its date,
 * with today's date in a filled disc.
 */
const props = defineProps<{ date: Date }>();

// UTC, because that is how the date arrives. Mobiscroll hands the column its
// midnight as a UTC instant, so formatting it in the browser's zone renders the
// previous day for anywhere west of UTC -- the whole header row then reads one
// day early while the grid underneath is correct.
const day = computed(() => moment.utc(props.date));
const dayLetter = computed(() => day.value.format("dd").charAt(0));
const dayNumber = computed(() => day.value.format("D"));
const isToday = computed(() =>
  day.value.isSame(moment.utc(moment().format("YYYY-MM-DD")), "day")
);
</script>
